import React, { FC, useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { useTheme } from 'styled-components';
import { useTranslate } from '@/translations';
import { useStockByStatus } from '@/api/OperationsDashboard';
import { ChartCard } from './ChartCard';

const HEIGHT = 300;

export const StockByStatusChart: FC = () => {
  const { t } = useTranslate();
  const { primaryChartColor } = useTheme();
  const { data, isLoading, isError, refetch } = useStockByStatus();

  const rows = useMemo(
    () =>
      (data ?? []).map((r) => ({ label: r.category ?? '', count: r.count })),
    [data],
  );

  const options: echarts.EChartsOption = useMemo(
    () => ({
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: { left: 8, right: 16, top: 16, bottom: 24, containLabel: true },
      xAxis: {
        type: 'category',
        data: rows.map((r) => r.label),
        axisLabel: { interval: 0, rotate: 30 },
      },
      yAxis: { type: 'value' },
      series: [
        {
          type: 'bar',
          data: rows.map((r) => r.count),
          itemStyle: { color: primaryChartColor },
        },
      ],
    }),
    [rows, primaryChartColor],
  );

  return (
    <ChartCard
      title={t('dashboard.widget.stockByStatus')}
      isLoading={isLoading}
      isError={isError}
      isEmpty={data?.length === 0}
      onRetry={() => refetch()}
      height={HEIGHT}
    >
      <ReactECharts option={options} style={{ height: HEIGHT }} />
    </ChartCard>
  );
};
